import Api from '@/api/index'

export function deriveSicoobKey(companyName) {
  if (!companyName) return ''

  return companyName
    .replace(/\s/g, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .toLowerCase()
    .replace(/ã/g, 'a')
}

export function labelFromSicoobKey(key) {
  if (!key) return ''
  return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export function companyRecord(company) {
  if (!company || typeof company === 'string') return null
  return company.attributes || company
}

export function companyGatewayKey(company) {
  return companyRecord(company)?.gateway_key || ''
}

export function companyCredentialsWarningMessage(company, fallbackName = '') {
  const record = companyRecord(company)
  const companyLabel = record?.fantasyName || record?.name || fallbackName

  if (!companyLabel) {
    return 'Gateway key da empresa não cadastrada. Solicite o cadastro.'
  }

  return `Gateway key da empresa não cadastrada (${companyLabel}). Solicite o cadastro.`
}

export default {
  data() {
    return {
      sicoob_credential_keys: [],
    }
  },
  computed: {
    sicoob_credential_options() {
      return this.sicoob_credential_keys.map((key) => ({
        key,
        name: labelFromSicoobKey(key),
      }))
    },
  },
  methods: {
    getSicoobCredentials() {
      if (this.sicoob_credential_keys.length) {
        return Promise.resolve(this.sicoob_credential_keys)
      }

      if (this._sicoob_credentials_loading) {
        return this._sicoob_credentials_loading
      }

      this._sicoob_credentials_loading = Api.Company.sicoobCredentials()
        .then((r) => r.data)
        .then((res) => {
          this.sicoob_credential_keys = res.keys || []
          return this.sicoob_credential_keys
        })
        .finally(() => {
          this._sicoob_credentials_loading = null
        })

      return this._sicoob_credentials_loading
    },
    hasSicoobCredentials(companyOrName) {
      if (!companyOrName) return false

      if (typeof companyOrName === 'string') {
        return this.hasSicoobCredentialKey(deriveSicoobKey(companyOrName))
      }

      return this.hasSicoobCredentialKey(companyGatewayKey(companyOrName))
    },
    hasSicoobCredentialKey(key) {
      return !!key && this.sicoob_credential_keys.includes(key)
    },
    findCompanyForFiscalNote(companies, fiscalNote) {
      if (!Array.isArray(companies) || !fiscalNote) return null

      const companyId = fiscalNote.company_id
      const companyName = fiscalNote.company_name

      return companies.find((company) => {
        const record = companyRecord(company) || {}
        const id = record.id ?? company.id
        if (companyId != null && id != null && String(id) === String(companyId)) {
          return true
        }
        return !!companyName && record.name === companyName
      }) || null
    },
  },
}
